export const PROPOSE_NOMINEE_SUCCESS = 'PROPOSE_NOMINEE_SUCCESS';
export const PROPOSE_NOMINEE_FAILURE = 'PROPOSE_NOMINEE_FAILURE';

export const FETCH_VOTED_NOMINATION_SUCCESS = 'FETCH_VOTED_NOMINATION_SUCCESS';
export const FETCH_VOTED_NOMINATION_FAILURE = 'FETCH_VOTED_NOMINATION_FAILURE';
export const CLEAR_VOTED_NOMINATION = 'CLEAR_VOTED_NOMINATION';

export const VOTE_NOMINEE_SUCCESS = 'VOTE_NOMINEE_SUCCESS';
export const VOTE_NOMINEE_FAILURE = 'VOTE_NOMINEE_FAILURE';

export const VOTE_NOMINEE_CLOSED = 'VOTE_NOMINEE_CLOSED';

export const FETCH_LIST_NOMINATIONS_SUCCESS = 'FETCH_LIST_NOMINATIONS_SUCCESS';
export const FETCH_LIST_NOMINATIONS_FAILURE = 'FETCH_LIST_NOMINATIONS_FAILURE';

export const SET_CURRENT_NOMINATION_SUCCESS = 'SET_CURRENT_NOMINATION_SUCCESS';
export const SET_CURRENT_NOMINATION_FAILURE = 'SET_CURRENT_NOMINATION_FAILURE';

export const SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS = 'SET_ARCHIVE_CURRENT_NOMINATION_SUCCESS';
export const FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS = 'FETCH_ARCHIVE_LIST_NOMINATIONS_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js